const initial = {
  group_id: null,
  status: 'hidden',
  callback: null
};

export default {
  namespaced: true,
  state: {...initial},
  actions: {
    clear({commit}) {
      commit('CLOSE_FORM');
    },
    create({commit}, {callback}) {
      commit('SHOW_FORM', {
        status: 'create',
        group_id: null,
        callback
      });
    },
    edit({commit}, {
      group_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'edit',
        group_id: group_id,
        callback
      });
    }
  },
  mutations: {
    CLOSE_FORM(state) {
      state.status = initial.status;
      state.group_id = initial.group_id;
      state.callback = initial.callback;
    },
    SHOW_FORM(state, {
      status,
      group_id,
      callback
    }) {
      state.status = status;
      state.group_id = group_id;
      state.callback = callback || initial.callback;
    }
  }
};
